import { render, staticRenderFns } from "./NameDisplayEditBlock.vue?vue&type=template&id=4a45aa24&scoped=true&"
import script from "./NameDisplayEditBlock.vue?vue&type=script&lang=js&"
export * from "./NameDisplayEditBlock.vue?vue&type=script&lang=js&"
import style0 from "./NameDisplayEditBlock.vue?vue&type=style&index=0&id=4a45aa24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a45aa24",
  null
  
)

export default component.exports